import { useEffect, useRef } from 'react';
import { useOutletContext } from 'react-router-dom';
import { AutoSizer, List, WindowScroller } from 'react-virtualized';

import useScreenSize from '@/hooks/useScreenSize';
import VerifyGalleryArtworkCard from '@/shared-components/cards/components/VerifyGalleryArtworkCard';

import './index.css';

export default function VerifiedArtworks() {
  const { fetchData } = useOutletContext();
  const screenSize = useScreenSize();
  const listRef = useRef();

  useEffect(() => {
    if (listRef.current) {
      listRef.current.recomputeRowHeights();
    }
  }, [screenSize.width]);

  return (
    <>
      <WindowScroller>
        {({ height, isScrolling, onChildScroll, scrollTop }) => (
          <AutoSizer disableHeight>
            {({ width }) => (
              <List
                autoHeight
                width={width === 0 ? 0.1 : width}
                height={height}
                isScrolling={isScrolling}
                onScroll={onChildScroll}
                rowCount={fetchData.artworks.length}
                rowHeight={screenSize.width <= 1004 ? 165 : 231}
                scrollTop={scrollTop}
                overscanRowCount={3}
                ref={listRef}
                rowRenderer={({ index, key, style }) => (
                  <div key={key} style={style}>
                    <VerifyGalleryArtworkCard artworkData={fetchData.artworks[index]} />
                  </div>
                )}
              />
            )}
          </AutoSizer>
        )}
      </WindowScroller>
    </>
  );
}
